// extracted by mini-css-extract-plugin
export default {"layout":"layout_layout__emTve","main":"layout_main__NS9px"};